import { createSlice } from "@reduxjs/toolkit";

export const translationSlice = createSlice({
  name: "translation",
  initialState: {
    currentLanguage: "ro",
  },
  reducers: {
    setCurrentLang: (state, action) => {
      state.currentLanguage = action.payload;
    },
  },
});

export const { setCurrentLang } = translationSlice.actions;

export default translationSlice.reducer;
